<template>
  <div class="filter-tree-wrapper">
    <div v-if="treeData.length<1" class="filter-description">
      <span>{{$t("shop_descriptionProduktfilter")}}</span>
    </div>
    <div class="filter-description">
      <button class="shop__button--activateFilter" @click="toggleFilter" >{{voreingestellteFilterText}}</button>
    </div>
    <div v-for="(item, index) in treeData" :key="index" class="filter-tree">
      <FilterTreeViewCategory :item="item" @dirty="$emit('dirty')"/>
    </div>
    <div class="new-category-wrapper">
      <input class="new-category" type="text" :placeholder="$t('shop_newCategoryPlaceholder')" v-model="newCategory" @keyup.enter="addNewCategory">
      <button v-if="newCategory.trim()!==''" @click="addNewCategory" class="btn-new-category">{{$t("shop_add")}}</button>
    </div>
  </div>
  <div class="save-wrapper">
    <button v-if="product!==null" @click="saveTagsForProduct" class="km__button--standard blue">{{$t("konf_Save")}}</button>
  </div>
</template>

<script lang="ts">
import {useShopItems} from "~/store/shopItemsStore";
import {useShopInfos} from "~/store/shopInfosStore";
import FilterTreeViewCategory from "~/components/FilterTreeViewCategory.vue";
import {sendPostRequest} from "@k/global/axiosFormWrapper";

export default {
  name: "FilterTreeView",
  components: {FilterTreeViewCategory},
  props: {
    product: Object
  },
  setup(props, context) {
    const shopItems= useShopItems();
    const shopInfos = useShopInfos();
    const newCategory = ref('');
    const positione = ref(9999);
    const i18n = useI18n();

    const voreingestellteFilterText = computed(()=>{
      if(shopInfos.shopInfo.voreingestellteFilterVerwenden){
        return i18n.t("shop_deactivateFilter");
      }
      else{
        return i18n.t("shop_activateFilter");
      }
    });

    function isTagAddedToProduct(category, tag){
      if(props.product === null){
        return false;
      }
      if(props.product.tags===undefined){
        return false;
      }
      if(props.product.tags.filter(obj => obj.category === category).length<1){
        return false;
      }
      return props.product.tags.filter(obj => obj.category === category)[0].tags.filter(item => item.name===tag).length > 0;
    }

    const treeData = computed(()=> shopItems.getFilterTags ?
        shopItems.getFilterTags.map(obj => ({
          category:obj.category,
          id: obj.id,
          positione: obj.positione,
          tags: obj.tags.map(tag => {return {
            name: tag.tag,
            id: tag.id,
            checked: isTagAddedToProduct(obj.category, tag.tag)
          }})
        })) : []
    )

    function saveTagsForProduct(){
      const selectedFilters = treeData.value.map(category => ({
            category: category.category,
            tags: category.tags.filter(tag => tag.checked)
          })).filter(category => category.tags.length > 0);
      shopItems.saveTagsForSaveID({shopname: shopInfos.shopname, saveID: props.product.saveID, filters: selectedFilters});
      context.emit('close_popup');
    }

    function addNewCategory(){
      if (newCategory.value.trim()) {
        shopItems.addCategory({shopname: shopInfos.shopname, category:newCategory.value, positione:positione.value});
        newCategory.value = '';
      }
    }

    function toggleFilter(){
      const value = !shopInfos.shopInfo.voreingestellteFilterVerwenden
      sendPostRequest("/shop_php/setFilterActivated.php", {value: value ? 1 : 0, shopname: shopInfos.shopname}).then(reponse=>{
        shopInfos.SET_FILTER_VERWENDEN(value);
      });
    }

    return{
      treeData,
      saveTagsForProduct,
      newCategory,
      addNewCategory,
      toggleFilter,
      voreingestellteFilterText
    }
  }
}
</script>

<style lang="scss" scoped>

@use "~/assets/scss/settings/_config.scss" as *;

.new-category-wrapper {
  background-color: #EEEEEE;
  height: 42px;
  padding-top: 8px;

  .new-category {
    font-size: 14px;
    height: 24px;
    margin-right: 0px;
    margin-left: 12px;
    padding-left: 10px;
    border: 1px solid #C0BEBF;
    width: 330px;
  }
}

.save-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 40px;

  .blue {
    width: 180px;
  }
}

.km__button--standard{
  margin-top: 0;
  margin-bottom: 20px;
}

.btn-new-category {
  margin-left: 10px;
  padding: 5px 10px;
  border-radius: 4px;
  background: $color-blue;
  color: $color-white;
  border: none;
  font-size: 14px;
}

.filter-description {
  margin-bottom: 50px;
  white-space: pre-wrap;
}

.shop__button--activateFilter{
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  width: 300px;
  height: 35px;
}

</style>